import { toString30pk9tzaqopn as toString } from './Library.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from './js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from './js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PairClass;
function Pair() {
  if (PairClass === VOID) {
    class $ {
      constructor(first, second) {
        this.xe_1 = first;
        this.ye_1 = second;
      }
      toString() {
        return '(' + toString(this.xe_1) + ', ' + toString(this.ye_1) + ')';
      }
      ze() {
        return this.xe_1;
      }
      af() {
        return this.ye_1;
      }
      ot(first, second) {
        return new (Pair())(first, second);
      }
      pt(first, second, $super) {
        first = first === VOID ? this.xe_1 : first;
        second = second === VOID ? this.ye_1 : second;
        return $super === VOID ? this.ot(first, second) : $super.ot.call(this, first, second);
      }
      hashCode() {
        var result = this.xe_1 == null ? 0 : hashCode(this.xe_1);
        result = imul(result, 31) + (this.ye_1 == null ? 0 : hashCode(this.ye_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Pair()))
          return false;
        if (!equals(this.xe_1, other.xe_1))
          return false;
        if (!equals(this.ye_1, other.ye_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Pair');
    PairClass = $;
  }
  return PairClass;
}
function to(_this__u8e3s4, that) {
  return new (Pair())(_this__u8e3s4, that);
}
var TripleClass;
function Triple() {
  if (TripleClass === VOID) {
    class $ {
      constructor(first, second, third) {
        this.qt_1 = first;
        this.rt_1 = second;
        this.st_1 = third;
      }
      toString() {
        return '(' + toString(this.qt_1) + ', ' + toString(this.rt_1) + ', ' + toString(this.st_1) + ')';
      }
      hashCode() {
        var result = this.qt_1 == null ? 0 : hashCode(this.qt_1);
        result = imul(result, 31) + (this.rt_1 == null ? 0 : hashCode(this.rt_1)) | 0;
        result = imul(result, 31) + (this.st_1 == null ? 0 : hashCode(this.st_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Triple()))
          return false;
        if (!equals(this.qt_1, other.qt_1))
          return false;
        if (!equals(this.rt_1, other.rt_1))
          return false;
        if (!equals(this.st_1, other.st_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Triple');
    TripleClass = $;
  }
  return TripleClass;
}
//region block: exports
export {
  Pair as Paire9pteg33gng7,
  Triple as Triple1vhi3d0dgpnjb,
  to as to2cs3ny02qtbcb,
};
//endregion

//# sourceMappingURL=Tuples.mjs.map
